import * as React from 'react'
import { SVGProps } from 'react'

const GenderFemaleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={40} {...props}>
    <defs>
      <clipPath id="GenderFemaleIcon">
        <path
          data-name="Rectangle 9037"
          transform="translate(839 1130)"
          fill="none"
          stroke="#707070"
          d="M0 0h48v40H0z"
        />
      </clipPath>
    </defs>
    <g data-name="Mask Group 548" transform="translate(-839 -1130)" clipPath="url(#GenderFemaleIcon)">
      <g data-name="Group 58535" fill="#263238">
        <path
          data-name="Ellipse 1775"
          d="M863.5 1133.8a10.7 10.7 0 0 0-7.566 18.266 10.7 10.7 0 1 0 15.132-15.132 10.63 10.63 0 0 0-7.566-3.134m0-1.8a12.5 12.5 0 1 1-12.5 12.5 12.5 12.5 0 0 1 12.5-12.5Z"
        />
        <path data-name="Path 86928" d="M864.72 1167h-1.8v-11h1.8Z" />
        <path data-name="Line 1622" d="M858.82 1162.81v-1.8h10v1.8Z" />
      </g>
    </g>
  </svg>
)

export default GenderFemaleIcon
